import { ListItemWrapper } from "../styles/styles";
import { useTranslation } from "@coworker/locales";
import { ItemListViewItemBasic } from "@coworker/apprestructured/src/media-maintenance/components/ItemListViewItemBasic/ItemListViewItemBasic";
import { LargeSkeletonListItem } from "@coworker/app/src/components/RoomSettings/Molecules/skeletons/LargeSkeletonListItem";
import { useCombinationArticle } from "@coworker/app/src/components/RoomSettings/hooks/useCombinationArticle";
import {
  useCountryId,
  useStoreId,
} from "@coworker/app/src/core/auth/useLoggedInUser";
import { mapArticleInfoToArticle } from "@coworker/app/src/components/RoomSettings/types/mappers";
import { LocalCombinationItem } from "@coworker/apprestructured/src/shared/types/localCombinationItem";
import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";

interface ReplacedArticleListItemProps {
  itemNo: string;
  numberBackup?: number;
  isSetAsBackupProduct?: boolean;
}

export function ReplacedArticleListItem({
  itemNo,
  isSetAsBackupProduct = false,
  numberBackup,
}: ReplacedArticleListItemProps) {
  const { t } = useTranslation();
  const countryId = useCountryId();
  const storeId = useStoreId();
  const { data: combinationItem, isLoading: isLoadingCombinationItem } =
    useCombinationArticle(storeId, countryId, itemNo);

  const badges = [] as ItemBadge[];
  if (isSetAsBackupProduct) {
    badges.push({
      colour: "blue",
      text:
        numberBackup === 1
          ? t("backupProductOneString")
          : t("backupProductTwoString"),
    });
  }

  const innerComponent = (
    <>
      {isLoadingCombinationItem && <LargeSkeletonListItem />}
      {!isLoadingCombinationItem && (
        <ItemListViewItemBasic
          badges={badges}
          article={mapArticleInfoToArticle(
            (
              combinationItem as LocalCombinationItem[]
            )?.[0] as LocalCombinationItem
          )}
          itemNo={itemNo}
          canCopyItemNo={false}
        />
      )}
    </>
  );

  return (
    <>
      <ListItemWrapper $hasBanner={false}>{innerComponent}</ListItemWrapper>
    </>
  );
}
